const BaseUrl = `https://homebackend.enatgames.com/`;
//const BaseUrl = `http://192.168.8.22:3008/`;
export default BaseUrl;
